/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolStarIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-star"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 17.65L8.03 20.05Q7.65 20.27 7.25 20.25Q6.85 20.23 6.55 20Q6.25 19.77 6.1 19.41Q5.95 19.05 6.05 18.63L7.1 14.07L3.58 11.03Q3.23 10.75 3.15 10.36Q3.08 9.97 3.2 9.63Q3.33 9.28 3.63 9.03Q3.92 8.78 4.35 8.72L8.97 8.32L10.78 4.05Q10.95 3.63 11.29 3.44Q11.63 3.25 12 3.25Q12.38 3.25 12.71 3.44Q13.05 3.63 13.22 4.05L15.03 8.32L19.65 8.72Q20.07 8.78 20.38 9.03Q20.68 9.28 20.8 9.63Q20.93 9.97 20.85 10.36Q20.77 10.75 20.43 11.03L16.9 14.07L17.95 18.63Q18.05 19.05 17.9 19.41Q17.75 19.77 17.45 20Q17.15 20.23 16.75 20.25Q16.35 20.27 15.97 20.05Z" fill={color} />
    </svg>
  );
}
